import { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { MainStoreState } from 'modules/main/store/MainStoreState';
import { setError } from 'modules/main/store/ducks/error.actions';
import { log } from 'utils/logging';

import { ModalByType } from './ModalByType';
import { ModalPropsForType } from './ModalPropsForType';
import { ModalType } from './ModalType';

type OwnProps<T extends ModalType = ModalType> = {
  type?: T;
  props?: ModalPropsForType<T>;
};

type Props = OwnProps & PropsFromRedux;

class UnconnectedModalRoot extends Component<Props> {
  componentDidCatch(
    error: Error,
    info: {
      componentStack: string;
    },
  ) {
    log.error(`stacktrace:\n${info.componentStack}`);

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.setError(error);
  }

  render() {
    const { type, props } = this.props;
    if (!type || !props) return null;

    return <ModalByType type={type} modalProps={props} />;
  }
}

const connector = connect((state: MainStoreState) => state.modal, { setError });

type PropsFromRedux = ConnectedProps<typeof connector>;

// @ts-expect-error TS(2345): Argument of type 'typeof UnconnectedModalRoot' is ... Remove this comment to see the full error message
export const ModalRoot = connector(UnconnectedModalRoot);
